import { Head, Link } from "@inertiajs/react";
import { taxon_path } from "@/routes.js";
import pageTitle from "@/utils/pageTitle";

export default function Index({ taxons }) {
  return (
    <>
      <Head title={pageTitle("Готовые композиции из шаров")} />
      <div className="container mx-auto py-16">
        <div className="grid lg:grid-cols-3 gap-6 py-4 xl:py-12">
          {taxons.map((taxon) => (
            <Link href={taxon_path(taxon.permalink)}>
              <div
                className="flex bg-gray-50 rounded-3xl overflow-hidden shadow cursor-pointer items-center"
                key={`taxon-thumb-${taxon.id}`}
              >
                <img src={taxon.thumb} className="size-25 rounded-3xl" />
                <div className="p-2 space-y-2">
                  <div className="text-xl xl:text-lg leading-5">
                    {taxon.pretty_name}
                  </div>
                  <div
                    className="text-xs xl:text-xs leading-tight text-gray-600 line-clamp-3 [&>div]:line-clamp-3"
                    dangerouslySetInnerHTML={{
                      __html: taxon.description.body,
                    }}
                  />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}

